import React from "react";
import "../Styles/slideshow.css"

const Slideshow = () => {


  return(
    <div className="container">
  <div className="box">
    <img src="https://purewows3.imgix.net/images/articles/2020_04/blue_apron_meal_kit.png"></img>
    <span>Fresh</span>
  </div>
  <div className="box">
    <img src="https://purewows3.imgix.net/images/articles/2020_04/Brownsville_Community_Culinary_Center_and_Collective_Fare_meal_kit.png"></img>
    <span>Sustainable</span>
  </div>
  <div className="box">
    <img src="https://www.qwick.com/wp-content/uploads/2021/06/Start-Staff-a-Delivery-Only-Restaurant.jpeg"></img>
    <span>Meal Kits</span>
  </div>
  <div className="box">
    <img src="https://i.guim.co.uk/img/media/4596e2e74b5f9d4e98c3aba47b0d842442423e05/568_461_1807_1084/master/1807.jpg?width=620&quality=85&auto=format&fit=max&s=8a5668cc0217ccf356cf104e3625df90"></img>
    <span>Produce</span>
  </div>
  {/* <div className="box">
    <img src="https://purposemart.com/images/blog/2/_ECO-FRIENDLY_PRACTICES_FOR_SUSTAINABLE_LIVING__4_.png"></img>
    <span>Regenerate</span>
  </div> */}
  <div className="box">
    <img src="https://upserve.com/media/sites/2/Copy-of-Reiner-4534-1024x683.jpg"></img>
    <span>Nutritious
    </span>
  </div>
</div>
  )

};


export default Slideshow;
